export const creditnotes = {
  alerts: {
    missingFcFiles_one: 'The PDF for this credit note can’t be found.',
    missingFcFiles_other: 'The PDFs for these credit notes can’t be found.',
    successCreated: 'Your credit note has been created.',
  },
  breadcrumb: {
    create: 'Create credit note',
    overview: 'Credit notes',
  },
  create: {
    blocker: 'Are you sure you want to leave this page? Your credit note has not been saved.',
    confirmation: {
      description:
        'Are you sure you want to create the credit note? Once the credit note has been approved and sent to your client, you can no longer make changes.',
      sentWithPeppol: 'Your credit note will be sent via Peppol after approval.',
      submit: 'Yes, create credit note',
      title: 'Your credit note is being sent to us',
    },
    error: {
      title: 'Error loading the credit note.',
    },
    partialPaymentsWarning: {
      message_one:
        'We’ve already received a partial payment of {{ payment }} for this invoice. Feel free to credit the invoice, we’ll follow up on this payment with you.',
      message_other:
        'We’ve already received partial payments of {{ payment }} for this invoice. Feel free to credit the invoice, we’ll follow up on these payments with you.',
      title: 'A heads-up!',
    },
    submit: 'Create credit note',
    title: 'New credit note',
  },
  fields: {
    invoiceId: {
      label: 'Credit note for invoice',
      placeholder: 'Select an invoice',
    },
    numberingSeriesId: {
      helpText: 'The credit note number will be <0>{{entryNumber}}</0>.',
      tooltip: 'This is a preview of your credit note number. The number only becomes final when you send the credit note to us.',
    },
    reason: {
      helpText: 'Note: the reason is visible to your client on the credit note.',
      label: 'Reason',
      placeholder: 'Enter your reason here',
    },
  },
  overview: {
    columns: {
      client: 'Client',
      date: 'Date',
      entryNumber: 'Credit note',
      reason: 'Reason',
      status: {
        options: {
          Approved: 'Approved',
          InReview: 'Pending approval',
        },
        sentWithPeppolTooltip: 'via Peppol',
        title: 'Status',
      },
      total: 'Credited',
    },
    created: {
      subtitle: 'Credit notes',
    },
    error: {
      title: 'Error loading your credit notes.',
    },
    rowActions: {
      download: 'Download',
    },
  },
};
